<script lang="ts">
  import { ButtonType } from "../../types/button-type";

  export let disabled: boolean = false;
  export let type: ButtonType = ButtonType.Primary;
  export let outlined: boolean = false;
</script>

<button class:disabled class={type} class:outlined on:click>
  <slot />
</button>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  button {
    width: -moz-available;
    width: -webkit-fill-available;
    width: fill-available;

    padding: 0.75rem 1rem;
    align-self: center;
    font-family: "Roboto";
    font-size: $font-size-medium;
    font-weight: $font-weight-bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &.disabled {
      pointer-events: none;
      cursor: none;
      opacity: 0.5;
    }

    &.primary {
      color: $color-white;
      background-color: $color-primary;

      &.outlined {
        border: 2px solid $color-white;
      }
    }

    &.secondary {
      color: $color-primary;
      background-color: $color-white;

      &.outlined {
        border: 2px solid $color-primary;
      }
    }
  }
</style>
